import { TrendingDown, TrendingUp } from 'lucide-react';
import React from 'react';
import { Card, Col, Row } from 'react-bootstrap';

interface MetricContent {
  title: string;
  value: string | number;
  description?: string;
  trend?: 'up' | 'down';
}

interface MetricData {
  content: MetricContent;
}

interface MetricCardProps {
  metric: MetricData;
}

const MetricCard: React.FC<MetricCardProps> = ({ metric }) => {
  return (
    <Card className="metric-card h-100">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-start">
          <Card.Title className="metric-title">
            {metric.content.title}
          </Card.Title>
          {metric.content.trend && (
            <div className={`trend-icon ${metric.content.trend}`}>
              {metric.content.trend === 'up' ? (
                <TrendingUp size={20} />
              ) : (
                <TrendingDown size={20} />
              )}
            </div>
          )}
        </div>
        <div className="metric-value">{metric.content.value}</div>
        <Card.Text className="metric-description text-muted">
          {metric.content.description}
        </Card.Text>
      </Card.Body>
    </Card>
  );
};

interface MetricCardCollectionBlock {
  content?: {
    cards: MetricData[];
  };
}

interface MetricCardCollectionProps {
  block: MetricCardCollectionBlock;
}

const MetricCardCollection: React.FC<MetricCardCollectionProps> = ({
  block,
}) => {
  if (!block.content?.cards) return null;

  return (
    <Row className="g-4">
      {block.content.cards.map((card, index) => (
        <Col key={index} md={4}>
          <MetricCard metric={card} />
        </Col>
      ))}
    </Row>
  );
};

export default MetricCardCollection;
